// Image Background Change
const images = [
    'url("/theme/helios/images/cae63f86-2b9e-4a33-98e8-f247e0347c15.png")',
    'url("/theme/helios/images/1682fa0f-44dc-4bac-93cf-1e7d06c37c55.png")',
    'url("/theme/helios/images/8b468404-5167-4fcf-ba29-864a3460a0ca.png")',
    'url("/theme/helios/images/59b3b670-7029-4702-88ea-cc8e36b90f36.png")',
    'url("/theme/helios/images/aa4d6e60-bad7-4bad-8918-34912273b80f.png")',
    'url("/theme/helios/images/23f8d26f-77c7-477c-96be-496bfe61a256.png")'
];
function startSpinner() {
    document.getElementById('spinner').style.display = 'block';
}
function stopSpinner() {
    document.getElementById('spinner').style.display = 'none';
}
let myTimeout = null;
onload = (event)=>{
    // stopSpinner();
    const nodes = document.querySelectorAll('a');
    for(let i = nodes.length; i--;)nodes[i].addEventListener('click', function() {
        myTimeout = setTimeout(startSpinner, 300);
    });
};
onpageshow = (event)=>{
    clearTimeout(myTimeout);
    stopSpinner();
};
// @ts-ignore
window.startSpinner = startSpinner;

//# sourceMappingURL=app.twig.7a1d3b1b.js.map
